import { yupLocalized } from "@ryde/shared";

export enum BackupCreateForm {
  /** Company ids plus, optionally, the global sentinel — one multi-select covers both scopes. */
  scopes = "scopes",
  entityNames = "entityNames",
}

export interface IBackupCreateForm {
  [BackupCreateForm.scopes]: (number | string)[];
  [BackupCreateForm.entityNames]: string[];
}

export const backupCreateValidationSchema = {
  [BackupCreateForm.scopes]: yupLocalized.array().min(1),
  [BackupCreateForm.entityNames]: yupLocalized
    .array()
    .of(yupLocalized.string())
    .min(1),
};
